import { jsxs as i, jsx as r } from "react/jsx-runtime";
const l = (t) => /* @__PURE__ */ i(
  "svg",
  {
    width: "512",
    height: "512",
    viewBox: "0 0 512 512",
    fill: "rgb(var(--fill-primary))",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      /* @__PURE__ */ r("path", { d: "M6 221.092C6 119.718 6 69 37.5 37.5C69 6 119.717 6 221.091 6H290.904C392.31 6 442.998 6 474.498 37.5C505.998 69 505.998 119.719 505.998 221.093V290.906C505.998 392.312 505.998 442.999 474.498 474.499C442.998 505.999 392.311 505.999 290.905 505.999H221.092C119.718 505.999 68.999 505.999 37.499 474.499C5.999 442.999 6 392.311 6 290.905V221.092Z" }),
      /* @__PURE__ */ r(
        "path",
        {
          d: "M375.28 96.3111H305.936C305.936 153.343 271.061 204.436 218.03 240.936L197.186 255.53V96.3101H125.156V415.685H197.186V257.374L316.373 415.686H404.279L289.624 264.217C341.748 226.342 375.748 167.499 375.28 96.3111Z",
          fill: "white"
        }
      )
    ]
  }
);
export {
  l as KlarnaIcon
};
